
import {computed} from 'vue'
import {useStore} from 'vuex';

export default {
  name: 'EleEmptyLayout',
  setup() {
    const {state} = useStore();
    const include = computed(() => state.theme.keepAliveInclude);
    const exclude = computed(() => state.theme.keepAliveExclude);
    return {
      include,
      exclude
    };
  }
}
